module.exports = __webpack_public_path__ + "img/logo.31b7b11f.png";